
import { defineComponent } from 'vue'
import MembersNewMemberForm from '@/components/members/forms/new-member.vue'
import OrganizationsNewOrganizationMemberForm from '@/components/organizations/forms/new-organization-member.vue'
import { useRoute } from 'vue-router'
import { OrganizationsRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'view-members-new-member',
    components: {
        MembersNewMemberForm,
        OrganizationsNewOrganizationMemberForm
    },
    setup () {
        const route = useRoute()
        const isAddedNewMemberToOrganization = route.name === OrganizationsRouteNames.MEMBERS_NEW

        return {
            isAddedNewMemberToOrganization
        }
    }
})
